export const APP_FILE_NOTICES_LIST = "/notices";
